module.exports = __webpack_public_path__ + "img/prereqs.30bf3984.png";